// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1521) return "static/chunks/1521-a5e9c4540c536136.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3141":"a2b62799dd535afd","4229":"29feb8e8c66f1a04"}[chunkId] + ".js";
};